import styled from 'styled-components'
import { colors } from '../../../theme'

export const PrincipalDiv = styled.div`
  margin-top: 20px;
  background-color: ${colors.surface};
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  padding: 20px;

  h3 {
    font-size: 16px;
  }
`
export const DivForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  align-items: start;
  margin-top: 25px;
`
export const FormLogin = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  span {
    color: ${colors.errorText};
    font-size: 13px;
    margin-left: 13px;
    margin-top: 3px;
  }
`
export const LabelLogin = styled.label`
  position: absolute;
  top: -9px;
  background: ${colors.surface};
  color: ${colors.grey500};
  left: 15px;
  padding: 0 3px;
  font-size: 12px;
`
export const InputLogin = styled.input`
  /* Transparente de proposito: o rotulo flutuante recorta a borda deste campo, e
     esse recorte so funciona se campo e container tiverem a MESMA cor. Com o campo
     preenchido, o rotulo atravessa a fronteira e vira uma caixa visivel. Campos SEM
     rotulo flutuante (busca, filtros) seguem preenchidos pela base do GlobalStyle. */
  background-color: transparent;
  width: 320px;
  height: 23px;
  border: 1px solid ${colors.grey300};
  border-radius: 12px;
  font-size: 14px;
  padding: 20px 20px 20px 15px;
`
export const DivAccess = styled.div`
  margin: 30px 0;
  display: flex;
  gap: 20px;
  flex-direction: column;
  width: 25%;
  position: relative;

  span {
    display: flex;
    align-items: start;
  }
`
export const BtnSave = styled.button`
  margin: 30px 0;
  cursor: pointer;
  background-color: ${colors.accentBg};
  color: ${colors.white};
  border: none;
  width: 240px;
  height: 40px;
  border-radius: 16px;
`
export const Search = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`
export const InputStyle = styled(InputLogin)<{
  border: string
  sizeY: string
  sizeX: string
}>`
  border: 1.5px solid ${({ border }) => border};
  border-radius: 12px;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  font-size: 12px;
`
export const B = styled.b`
  font-weight: 600;
  font-size: 14px;
`

export const DivVinculos = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  .erro {
    display: block;
    color: ${colors.errorText};
    font-size: 13px;
    margin-left: 13px;
    margin-top: 6px;
  }
`

export const VinculoRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  align-items: center;

  /* Base fixa (sem crescer): os três campos têm a mesma largura tendo CPF ou não,
     pequena o suficiente para caberem todos + o botão Remover na mesma linha. */
  > div {
    flex: 0 1 300px;
    min-width: 0;
  }

  /* 42px = altura real renderizada do InputLogin sob o border-box global.
     Padding vertical 0 mantém o texto centralizado, sem o espaço interno exagerado. */
  input,
  select {
    width: 100%;
    height: 42px;
    padding: 0 15px;
  }
`

export const SelectVinculo = styled.select`
  /* Transparente de proposito: o rotulo flutuante recorta a borda deste campo, e
     esse recorte so funciona se campo e container tiverem a MESMA cor. Com o campo
     preenchido, o rotulo atravessa a fronteira e vira uma caixa visivel. Campos SEM
     rotulo flutuante (busca, filtros) seguem preenchidos pela base do GlobalStyle. */
  background-color: transparent;
  border: 1px solid ${colors.grey300};
  border-radius: 12px;
  font-size: 14px;
  background-color: ${colors.surface};
`

export const BtnAdicionar = styled.button`
  cursor: pointer;
  background-color: transparent;
  color: ${colors.primaryText};
  border: 1px dashed ${colors.secondary};
  width: 240px;
  height: 40px;
  border-radius: 16px;
  font-size: 14px;
`

export const BtnRemover = styled.button`
  flex-shrink: 0;
  cursor: pointer;
  background-color: ${colors.surface};
  color: ${colors.errorText};
  border: 1px solid ${colors.error};
  height: 40px;
  padding: 0 20px;
  border-radius: 16px;
  font-size: 14px;
  white-space: nowrap;
`
